module.exports = __webpack_public_path__ + "static/media/developer.2453c531.jpg";